import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/website/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/website/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/app/website/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/app/website/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/website/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["DisableDraftMode"] */ "/vercel/path0/app/website/src/root/contents/sanity/components/DisableDraftMode.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/website/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/website/src/styles/theme.css");
